/** Foundation · Sequence — "Dipendente 8 di 24 · 5/24 completati" con barra di avanzamento. */
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function SequenceProgress({ state, noun = "Dipendente", onPrev, onNext, testid = "sequence-progress" }) {
  if (!state.total) return null;
  const pct = Math.round((state.completed / state.total) * 100);
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <button type="button" onClick={onPrev} disabled={state.index <= 0} aria-label="Precedente" data-testid={`${testid}-prev`}
        className="rounded p-1 text-suite-neutral-500 hover:bg-suite-neutral-100 disabled:opacity-30"><ChevronLeft size={15} /></button>
      <div className="min-w-[170px]">
        <div className="flex justify-between gap-3 text-[11px]">
          <span className="font-medium text-suite-neutral-700" data-testid={`${testid}-position`}>{state.index >= 0 ? `${noun} ${state.position} di ${state.total}` : `${state.total} in elenco`}</span>
          <span className="text-suite-neutral-500" data-testid={`${testid}-completed`}>{state.completed} / {state.total} completati</span>
        </div>
        <div className="mt-1 h-1 overflow-hidden rounded-full bg-suite-neutral-100">
          <div className="h-full rounded-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <button type="button" onClick={onNext} disabled={state.index >= state.total - 1} aria-label="Successivo" data-testid={`${testid}-next`}
        className="rounded p-1 text-suite-neutral-500 hover:bg-suite-neutral-100 disabled:opacity-30"><ChevronRight size={15} /></button>
    </div>
  );
}

export default SequenceProgress;
